
/**
* 用工中心 用工结算单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用工结算单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="任务名称: ">
            <el-input
              size="small"
              v-model="formInline.taskName"
              placeholder="请输入任务名称"
              @input="onSearchInput"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="结算单状态: ">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择"
              style="width: 100%"
              @change="onSearchInput"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="批次ID:">
            <el-input
              size="small"
              v-model="formInline.batchNumber"
              placeholder="请输入结算单批次ID"
              @input="onSearchInput"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="创建时间: ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
              @change="onSearchInput"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4"> </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button
        size="small"
        type="primary"
        @click="upload_dialog.visible = true"
        >上传结算单</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="taxRateDialogVisible = true"
        >查看税率表</el-button
      >
      <el-button size="small" @click="exprot_confirmlist"
        >导出任务确认单</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      @selection-change="handleSelectionChange"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" min-width="60">
      </el-table-column>
      <el-table-column
        fixed
        prop="batchNumber"
        label="结算单批次ID"
        min-width="120"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.batchNumber)">
            {{ scope.row.batchNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="batchName"
        label="结算单名称"
        min-width="120"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.batchName)">
            {{ scope.row.batchName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="任务名称"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.taskName)">
            {{ scope.row.taskName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="statusStr"
        label="结算状态"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getStatusColor(scope.row.status),
            }"
            >{{ scope.row.statusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="totalNum"
        label="总笔数"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="totalPay"
        label="应付总额（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalPay.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceFee"
        label="总服务费（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.serviceFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceFee"
        label="总管理费（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.managementFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="managementFeeMode"
        label="管理费承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.managementFeeMode === 1">企业承担</span>
          <span v-else-if="scope.row.managementFeeMode === 2">个人承担</span>

          <span v-else-if="scope.row.managementFeeMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxMode"
        label="个税承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2"
            >个人承担</span
          >

          <span v-else-if="scope.row.individualIncomeTaxMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceFee"
        label="个税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.individualIncomeTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.valueAddedTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.additionalTax.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column fixed="right" align="left" label="操作" min-width="220">
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.status === 0 ||
              scope.row.status === 8 ||
              scope.row.status === 9
            "
          >
            <el-button
              size="small"
              type="primary"
              plain
              @click="handlesSubmit(scope.row.batchNumber)"
              >提交</el-button
            >
            <el-button
              size="small"
              type="warning"
              @click="handlescancel(scope.row.batchNumber)"
              >取消</el-button
            >
          </div>
          <!-- 当 status 为 6 或 1 时 -->
          <div v-else-if="scope.row.status === 6 || scope.row.status === 1">
            <el-button
              size="small"
              type="primary"
              plain
              @click="handleDetail(scope.row.batchNumber)"
              >结算详情</el-button
            >
            <el-button
              size="small"
              type="primary"
              plain
              v-if="scope.row.status === 6"
              @click="
                handleshowconfirm(scope.row.batchNumber, scope.row.status)
              "
              >任务确认单</el-button
            >
            <el-button
              size="small"
              type="danger"
              v-if="scope.row.status === 1"
              @click="handlesdelete(scope.row.batchNumber)"
              >删除</el-button
            >
          </div>
          <div v-else>
            <el-button
              size="small"
              type="primary"
              plain
              @click="handleDetail(scope.row.batchNumber)"
              >结算详情</el-button
            >
            <el-button
              size="small"
              type="primary"
              plain
              @click="handleshowconfirm(scope.row.batchNumber)"
              >任务确认单</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="upload_dialog.title"
      :visible.sync="upload_dialog.visible"
      @open="upload_dialog_open"
      width="600px"
      @click="closeDialog"
      :rules="rules"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="结算单名称：" prop="batchName">
          <el-input
            style="width: 70%"
            size="small"
            v-model="editForm.batchName"
            auto-complete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务名称: " prop="taskId">
          <el-select
            style="width: 70%"
            size="small"
            v-model="editForm.taskId"
            placeholder="请选择"
          >
            <el-option
              v-for="(val, index) in taskId_list"
              :label="val.taskName"
              :value="val.taskId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下发渠道: " prop="distributionChannel">
          <el-select
            style="width: 70%"
            size="small"
            v-model="editForm.distributionChannel"
            placeholder="请选择"
          >
            <el-option
              v-for="(val, index) in distributionChannel_list"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="managementFeeMode" label="管理费承担:">
          <el-radio-group
            v-model="editForm.managementFeeMode"
            :disabled="isManagementFeeModeFixed"
          >
            <el-radio :label="1">企业承担</el-radio>
            <el-radio :label="2">个人承担</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          prop="individualIncomeTaxMode"
          v-if="taxCalculationSwitch == 1"
        >
          <template slot="label">
            <span>
              <el-tooltip
                effect="dark"
                content="含个人增值税及附加税"
                placement="top"
              >
                <i
                  class="el-icon-question"
                  style="color: #909399; cursor: pointer"
                ></i>
              </el-tooltip>
              个税承担:
            </span>
          </template>
          <el-radio-group
            v-model="editForm.individualIncomeTaxMode"
            :disabled="isIndividualIncomeTaxModeFixed"
          >
            <el-radio :label="1">企业承担</el-radio>
            <el-radio :label="2">个人承担</el-radio>
          </el-radio-group>
        </el-form-item>
        <div
          style="
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
          "
        >
          <el-button
            size="small"
            style="margin: 0 20px"
            @click="example_download"
            >模板下载</el-button
          >
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :on-remove="handleRemove"
            :on-change="file_on_change"
            :file-list="fileList"
            :auto-upload="false"
          >
            <el-button size="small" slot="trigger" type="primary"
              >选取文件</el-button
            >
          </el-upload>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="解析错误原因"
      :visible.sync="errMsgDialog.visible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-card class="box-card" shadow="hover">
        <div class="msg-container">
          <div
            v-for="msg in errMsgList"
            :key="msg"
            class="text item"
            :style="{
              color: getStatusColor(9),
            }"
          >
            {{ msg }}
          </div>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          :loading="exportErrMsgLoading"
          type="primary"
          @click="exportErrMsg()"
          >导出错误信息</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="税率表"
      :visible.sync="taxRateDialogVisible"
      width="70%"
      :close-on-click-modal="false"
      custom-class="tax-dialog"
      center
    >
      <div class="tax-content">
        <div class="formulas-section">
          <div class="formula-item">
            <h4 class="formula-title">
              <i class="el-icon-notebook-2"></i> 个税计算公式：
            </h4>
            <div class="formula-content">
              <ol>
                <!-- <li>
                  <strong>按月累计</strong>：个人所得税 = (当月总收入 × 80% -
                  5000) × 适用税率 - 速算扣除数
                </li>
                <li>
                  <strong>按年连续累计</strong>：个人所得税 = (当年累计总收入 ×
                  80% - 5000 × n) × 适用税率 - 速算扣除数 （n代表月份）
                </li> -->
                <li>
                  <strong>按年断档累计</strong
                  >（中途某月中断收入，下月重新累计计算）：个人所得税 =
                  (当年连续月累计总收入 × 80% - 5000 × n) × 适用税率 -
                  速算扣除数 （n代表连续收入月）
                </li>
              </ol>
            </div>
          </div>

          <div class="formula-item">
            <h4 class="formula-title">
              <i class="el-icon-notebook-2"></i> 增值税及附加税计算公式：
            </h4>
            <div class="formula-content">
              <p>月收入累计超过10万元</p>
              <p>增值税 = 累计收入 × 增值税率</p>
              <p>附加税 = 增值税 × 附加税率</p>
            </div>
          </div>
        </div>

        <div class="tax-table-section">
          <h3 class="section-title">个人所得税税率表</h3>
          <el-table
            :data="taxRateTableData"
            border
            size="medium"
            style="width: 100%"
          >
            <el-table-column
              prop="incomeRange"
              label="全年应纳税所得额"
              align="center"
              min-width="200"
              header-align="center"
            ></el-table-column>

            <el-table-column
              prop="taxRate"
              label="税率"
              align="center"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="quickDeduction"
              label="速算扣除数"
              align="center"
              header-align="center"
            ></el-table-column>
            <!-- <el-table-column
              prop="calculationExample"
              label="计算示例"
              align="center"
              min-width="250"
            ></el-table-column> -->
          </el-table>
          <p class="note-text">
            注：本表所称全年应纳税所得额是指依照税法规定，以累计收入× 80% -
            5000。
          </p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="taxRateDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="taxRateDialogVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deptList,
  settlementsList,
  settlementsupload,
  export_template,
  exportsettlementsList,
  checksettlementsList,
  putSettlementStatus,
  getManageFeeAndTaxMode,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import { Message, MessageBox } from "element-ui";
export default {
  data() {
    return {
      isManagementFeeModeFixed: false, // 管理费模式是否固定（不可修改）
      isIndividualIncomeTaxModeFixed: false, // 个税模式是否固定（不可修改）
      // 个税开关
      taxCalculationSwitch: false,
      // 新增：税率表对话框显示控制
      taxRateDialogVisible: false,

      // 新增：税率表数据
      taxRateTableData: [
        {
          incomeRange: "不超过36000元",
          taxRate: "3%",
          quickDeduction: "0元",
          calculationExample:
            "收入36000元：(36000 × 80% - 5000) × 3% - 0 = 714元",
        },
        {
          incomeRange: "超过36000元至144000元",
          taxRate: "10%",
          quickDeduction: "2520元",
          calculationExample:
            "收入144000元：(144000 × 80% - 5000) × 10% - 2520 = 8500元",
        },
        {
          incomeRange: "超过144000元至300000元",
          taxRate: "20%",
          quickDeduction: "16920元",
          calculationExample:
            "收入300000元：(300000 × 80% - 5000) × 20% - 16920 = 30080元",
        },
        {
          incomeRange: "超过300000元至420000元",
          taxRate: "25%",
          quickDeduction: "31920元",
          calculationExample:
            "收入420000元：(420000 × 80% - 5000) × 25% - 31920 = 50830元",
        },
        {
          incomeRange: "超过420000元至660000元",
          taxRate: "30%",
          quickDeduction: "52920元",
          calculationExample:
            "收入660000元：(660000 × 80% - 5000) × 30% - 52920 = 103980元",
        },
        {
          incomeRange: "超过660000元至960000元",
          taxRate: "35%",
          quickDeduction: "85920元",
          calculationExample:
            "收入960000元：(960000 × 80% - 5000) × 35% - 85920 = 181130元",
        },
        {
          incomeRange: "超过960000元",
          taxRate: "45%",
          quickDeduction: "181920元",
          calculationExample:
            "收入1000000元：(1000000 × 80% - 5000) × 45% - 181920 = 175830元",
        },
      ],

      polling: {
        isActive: false, // 轮询是否激活
        timer: null, // 定时器引用
        interval: 15000, // 轮询间隔(15秒)
        processingStatus: 3, // 处理中状态码
        retryCount: 0, // 重试次数
        maxRetries: 8, // 最大重试次数
        wasActiveBeforeSearch: false, // 搜索前的轮询状态
      },
      status_list: [
        {
          label: "校验中",
          value: 8,
        },
        {
          label: "验证失败",
          value: 9,
        },
        {
          label: "待提交",
          value: 0,
        },
        {
          label: "已取消",
          value: 1,
        },
        {
          label: "待结算",
          value: 2,
        },
        {
          label: "处理中",
          value: 3,
        },
        {
          label: "全部结算成功",
          value: 4,
        },
        {
          label: "部分结算成功",
          value: 5,
        },
        {
          label: "全部结算失败",
          value: 6,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      taskId_list: [],
      distributionChannel_list: [
        {
          label: "银行卡",
          value: 1,
        },
        // {
        //   label: "支付宝",
        //   value: 2,
        // },
      ],
      fileList: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      upload_dialog: {
        title: "上传结算单",
        visible: false,
      },
      errMsgDialog: {
        visible: false,
      },
      exportErrMsgLoading: false,
      downloadErrMsgUrl: "",
      errMsgList: [],
      title: "添加",
      editForm: {
        batchName: "",
        taskId: "",
        distributionChannel: "",
        individualIncomeTaxMode: "",
        managementFeeMode: "",
      },
      // rules表单验证
      rules: {
        batchName: [
          { required: true, message: "请输入结算单名称", trigger: "blur" },
        ],
        taskId: [
          { required: true, message: "请选择任务名称", trigger: "change" },
        ],
        distributionChannel: [
          { required: true, message: "请选择下发渠道", trigger: "change" },
        ],
        individualIncomeTaxMode: [
          { required: true, message: "请选择个税承担方式", trigger: "change" },
        ],
        managementFeeMode: [
          {
            required: true,
            message: "请选择管理费承担方式",
            trigger: "change",
          },
        ],
      },
      formInline: {
        date: [],
        status: "",
        page: 1,
        pageSize: 10,
        batchNumber: "",
        taskName: "",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  mounted() {
    // 组件挂载后初始化轮询
    this.initPolling();
  },
  beforeDestroy() {
    // 组件销毁前停止轮询
    this.stopPolling();
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.taxCalculationSwitch = JSON.parse(
      localStorage.getItem("user_info")
    ).taxCalculationSwitch;
    this.getdata(this.formInline);
    this.getMode();
    let params = {
      page: 1,
      pageSize: 100,
      taskId: "",
      taskName: "",
      status: 1,
      startDate: "",
      endDate: "",
      invoiceCategory: "",
    };
    deptList(params)
      .then((res) => {
        this.loading = false;
        if (res.msg == "success") {
          this.taskId_list = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  },

  methods: {
    getStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 0:
        case 2:
        case 3:
        case 8:
          return "#409EFF"; // 蓝色
        case 4:
          return "#67C23A"; // 绿色
        case 1:
          return "#909399"; // 灰色
        case 9:
        case 6:
          return "#F56C6C"; // 红色
        case 5:
          return "#E6A23C"; // 黄色
        default:
          return "#303133"; // 默认黑色
      }
    },

    // 初始化轮询
    initPolling() {
      this.stopPolling(); // 先停止可能存在的轮询
      this.polling.isActive = true;
      this.polling.retryCount = 0;
      this.startPolling();
    },

    // 启动轮询
    startPolling() {
      if (!this.polling.isActive) return;

      this.polling.timer = setInterval(() => {
        this.checkProcessingStatus();
      }, this.polling.interval);
    },

    // 停止轮询
    stopPolling() {
      if (this.polling.timer) {
        clearInterval(this.polling.timer);
        this.polling.timer = null;
      }
      this.polling.isActive = false;
    },

    // 检查处理中状态
    checkProcessingStatus() {
      const processingRecords = this.listData.filter((row) => {
        return row.status === this.polling.processingStatus;
      });

      if (processingRecords.length > 0) {
        this.getdata(this.formInline);
        this.polling.retryCount = 0;
      } else {
        this.polling.retryCount++;
        if (this.polling.retryCount >= this.polling.maxRetries) {
          this.polling.isActive = false;
          this.stopPolling();
        }
      }
    },
    // 搜索输入处理 - 立即停止轮询
    onSearchInput() {
      // 记录搜索前的轮询状态
      this.polling.wasActiveBeforeSearch = this.polling.isActive;

      // 停止轮询
      this.polling.isActive = false;
      this.stopPolling();
    },

    getMode() {
      getManageFeeAndTaxMode()
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            const { individualIncomeTaxMode, managementFeeMode } = res.data;
            // 处理管理费承担模式
            if (managementFeeMode !== 0) {
              this.editForm.managementFeeMode = managementFeeMode;
              this.isManagementFeeModeFixed = true; // 固定不可修改
            } else {
              this.isManagementFeeModeFixed = false; // 可自由选择
              this.editForm.managementFeeMode = ""; // 或者您想要的默认值
            }

            // 处理个税承担模式
            if (individualIncomeTaxMode !== 0) {
              this.editForm.individualIncomeTaxMode = individualIncomeTaxMode;
              this.isIndividualIncomeTaxModeFixed = true; // 固定不可修改
            } else {
              this.isIndividualIncomeTaxModeFixed = false; // 可自由选择
              this.editForm.individualIncomeTaxMode = ""; // 或者您想要的默认值
            }
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    reset() {
      this.formInline = {
        date: [],
        status: "",
        page: 1,
        pageSize: 10,
        batchNumber: "",
        taskName: "",
      };
      this.getdata(this.formInline);

      // 重新启动轮询
      this.polling.isActive = true;
      this.startPolling();
    },
    exprot_confirmlist() {
      if (this.multipleSelection.length > 0) {
        let data = [];
        this.multipleSelection.map((item) => {
          data.push(item.batchNumber);
        });
        exportsettlementsList({ batchNumberList: data })
          .then((res) => {
            if (res.msg == "success") {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.$message({
          type: "error",
          message: "请选择需要导出的确认单",
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    example_download() {
      export_template()
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    file_on_change(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
    },
    upload_dialog_open() {
      this.editForm.batchName = "";
      this.editForm.taskId = "";
      this.editForm.distributionChannel = "";
      this.fileList = [];
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      let params = {
        page: parameter.page,
        pageSize: parameter.pageSize,
        batchNumber: parameter.batchNumber,
        taskName: parameter.taskName,
        status: parameter.status,
        startDate: parameter.date[0] || "",
        endDate: parameter.date[1] || "",
      };
      settlementsList(params)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
      // 重新启动轮询
      this.polling.isActive = true;
      this.startPolling();
    },
    handlescancel(id) {
      let params = {
        status: 1,
      };
      putSettlementStatus(id, params)
        .then((res) => {
          if (res.msg == "success") {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    handlesdelete(id) {
      let params = {
        status: 7,
      };
      MessageBox.confirm(`此操作将永久删除结算单，是否继续?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        putSettlementStatus(id, params)
          .then((res) => {
            if (res.msg == "success") {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getdata(this.formInline);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {});
      });
    },
    handlesSubmit(id) {
      this.$router.push({
        path: "/task/employmentStatementSubmit",
        query: {
          id: id,
        },
      });
    },
    handleDetail(id) {
      this.$router.push({
        path: "/task/employmentStatementDetail",
        query: {
          id: id,
        },
      });
    },
    handleshowconfirm(val, status) {
      if (status == 6) {
        this.$message({
          type: "error",
          message: "结算单已经全部结算失败，无法生成确认单",
        });
        return;
      }
      checksettlementsList(val)
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if (
        this.editForm.batchName == "" ||
        this.editForm.taskId == "" ||
        this.editForm.distributionChannel == "" ||
        this.editForm.managementFeeMode == "" ||
        this.fileList.length == 0
      ) {
        this.$message({
          type: "error",
          message: "请先完善信息！",
        });
        return;
      }

      if (
        this.taxCalculationSwitch == 1 &&
        this.editForm.individualIncomeTaxMode == ""
      ) {
        this.$message({
          type: "error",
          message: "请选择个税承担模式！",
        });
        return;
      }

      if (this.taxCalculationSwitch != 1) {
        this.editForm.individualIncomeTaxMode == 0;
      }

      this.loading = true;
      this.$refs[editData].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("batchName", this.editForm.batchName);
          formData.append("taskId", this.editForm.taskId);
          formData.append(
            "distributionChannel",
            this.editForm.distributionChannel
          );
          formData.append(
            "individualIncomeTaxMode",
            this.editForm.individualIncomeTaxMode
          );
          formData.append("managementFeeMode", this.editForm.managementFeeMode);
          formData.append("file", this.fileList[0].raw);
          settlementsupload(formData)
            .then((res) => {
              this.loading = false;
              if (res.msg == "success") {
                this.upload_dialog.visible = false;
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else if (res.code == 703) {
                // 结算单数据验证失败
                this.upload_dialog.visible = false;
                this.errMsgDialog.visible = true;
                this.errMsgList = res.data.errMsgList;
                this.downloadErrMsgUrl = res.data.downloadUrl;
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.upload_dialog.visible = false;
    },
    exportErrMsg() {
      if (!this.downloadErrMsgUrl) {
        this.$message({
          type: "error",
          message: "文件还未生成",
        });
        return;
      }

      window.open(this.downloadErrMsgUrl);
    },

    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.msg-container {
  max-height: 300px; /* 设置最大高度，可根据需求调整 */
  overflow-y: auto; /* 当内容超出最大高度时显示垂直滚动条 */
}
.text {
  font-size: 14px;
}

.item {
  padding: 10px 0;
}

.tax-dialog .tax-content {
  padding: 0 5px;
}

.tax-dialog .formulas-section {
  margin-bottom: 25px;
  border-bottom: 1px dashed #e0e0e0;
  padding-bottom: 20px;
}

.tax-dialog .formula-item {
  margin-bottom: 20px;
}

.tax-dialog .formula-title {
  color: #409eff;
  font-size: 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.tax-dialog .formula-title i {
  margin-right: 8px;
  font-size: 18px;
}

.tax-dialog .formula-content {
  background-color: #f8fcff;
  border-left: 4px solid #409eff;
  padding: 12px 15px;
  border-radius: 0 4px 4px 0;
}

.tax-dialog .formula-content ol {
  padding-left: 20px;
  margin: 0;
}

.tax-dialog .formula-content li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.tax-dialog .formula-content p {
  margin: 8px 0;
  line-height: 1.6;
}

.tax-dialog .tax-table-section {
  margin-top: 15px;
}

.tax-dialog .section-title {
  text-align: center;
  color: #409eff;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.tax-dialog .note-text {
  font-size: 13px;
  color: #909399;
  margin-top: 12px;
  line-height: 1.5;
  font-style: italic;
}
</style>

<style >
.tax-dialog {
  border-radius: 10px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);
}

.tax-dialog .el-dialog__header {
  background: linear-gradient(135deg, #409eff 0%, #337ecc 100%);
  border-radius: 10px 10px 0 0;
  padding: 16px 20px;
}

.tax-dialog .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.tax-dialog .el-dialog__headerbtn {
  top: 16px;
}

.tax-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.tax-dialog .el-dialog__body {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}
.tax-dialog .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;
}

.tax-dialog .dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.tax-dialog .el-table {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tax-dialog .el-table th {
  background-color: #f0f7ff;
  color: #409eff;
  font-weight: 600;
}

.tax-dialog .el-table .el-table__row:hover td {
  background-color: #f5f9ff;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .tax-dialog.el-dialog {
    width: 85% !important;
  }
}

@media (max-width: 768px) {
  .tax-dialog.el-dialog {
    width: 90% !important;
  }

  .tax-dialog.el-dialog .el-dialog__body {
    padding: 15px;
  }

  .tax-dialog .formula-content {
    padding: 10px;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/task/employmentStatement.vue